import { ProgressBar, Text } from '@fluentui/react-components';
import { useStyles } from './styles.js';

type SyncStatusBarProps = {
    progress: number;
};

export function SyncStatusBar({ progress }: SyncStatusBarProps) {
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <Text className={styles.text}>Synchronisierung läuft... {progress}%</Text>
                <ProgressBar value={progress / 100} thickness="medium" className={styles.progressBar} />
            </div>
        </div>
    );
}
